<template>
    <v-card>
        <v-tabs
            v-model="tab"
            color="primary"
            align-tabs="center"
            touchless
            fixed-tabs
        >
            <v-tab :value="0">Vacaciones</v-tab>
            <v-tab :value="1">Calendario Laboral</v-tab>
        </v-tabs>
        <v-window v-model="tab">
            <v-window-item :value="0">
                <HolidaysView />
            </v-window-item>
            <v-window-item :value="1">
                <WorkingCalendarView />
            </v-window-item>
        </v-window>
    </v-card>
</template>

<script>
import HolidaysView from './WorkerHolidays/HolidaysView.vue';
import WorkingCalendarView from './WorkingCalendar/WorkingCalendarView.vue';

export default {
    name: 'HolidaysBase',
    components: {
        HolidaysView,
        WorkingCalendarView
    },
    data: () => ({
        tab: 0,
    }),
    created() {
        if(this.$store.state.holidays.workingCalendarObj.workingCalendar.length == 0){
            this.$store.dispatch('holidays/fetchWorkingCalendar', {});
        }

        this.$store.dispatch('holidays/getSpentHolidays');
    },
}
</script>